import script from "./AboutUs.vue?vue&type=script&lang=ts&setup=true"
export * from "./AboutUs.vue?vue&type=script&lang=ts&setup=true"

import "./AboutUs.vue?vue&type=style&index=0&id=e79c68ca&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e79c68ca"]])

export default __exports__